export default __webpack_public_path__ + "static/media/zora-proposal-intro.18fae695.jpg";